const foundLastNavigatedPath = (pathname, section) => {
  let element
  section.forEach((el) => {
    const foundItem = el.items.find((obj) => obj.href === pathname)
    if (foundItem) {
      element = foundItem
    }
  })
  return element
}
export default foundLastNavigatedPath
